import React, { FC, forwardRef } from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import shouldForwardProp from '@styled-system/should-forward-prop';

import { StyledIcon } from './CheckboxIcon';
import { BaseProps } from './types';

const StyledInput = styled('input', {
  shouldForwardProp,
})<BaseProps>(({ hasError, disabled, sx }) =>
  css({
    all: 'inherit',
    opacity: '0',
    zIndex: '2',
    position: 'absolute',
    left: 0,
    top: 0,
    height: sx?.['height'] || 'checkbox.height',
    width: sx?.['width'] || 'checkbox.minWidth',
    [`:hover ~ ${StyledIcon}`]: {
      borderColor: !hasError && !disabled && 'checkbox.hover.default',
    },
    [`:focus ~ ${StyledIcon}`]: {
      borderColor: !hasError && !disabled && 'checkbox.hover.default',
    },
  })
);

const CheckboxInput = forwardRef<HTMLInputElement, BaseProps>((props, ref) => (
  <StyledInput ref={ref} {...props} type="checkbox" />
));

export default CheckboxInput;
